export default __webpack_public_path__ + "static/media/Payitbrand.8077162c.png";